module.exports = __webpack_public_path__ + "img/main.9158906d.svg";